import { useQuery, UseQueryResult } from 'react-query';
import { posts } from '@/config/blog';
import { ReactQueryKeys } from './keys';

type Post = {
  id: string;
  tag: string;
  title: string;
  link: string;
  image: string;
};

const useGetPosts = (): UseQueryResult<Post[], Error> =>
  useQuery(ReactQueryKeys.GET_POSTS, () => posts);

export { useGetPosts };
